export default "__VITE_ASSET__C8zbark7__"